export const getDistanceLabel = (value: number, locale: string): string => {
  const distanceUnitMap: Record<string, string> = {
    uk: 'miles',
    fr: 'km',
    de: 'km',
  };
  const unit = distanceUnitMap[locale] || 'miles';
  return `${value} ${unit}`;
};

export const getMonthsLabel = (value: number, locale: string): string => {
  const monthsLabelMap: Record<string, string> = {
    uk: 'Months',
    fr: 'mois',
    de: 'Monate',
  };
  const unit = monthsLabelMap[locale] || 'Months';
  return `${value} ${unit}`;
};
